<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible="visible"
      :title="title"
      width="380px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
      :show-close="false"
      @close="cancel"
    >
      <div>
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="labelName">
            <el-date-picker
              v-model="selectDate"
              type="date"
              :editable="false"
              :clearable="false"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right">
          <el-button type="primary" @click="circulationFileHandler">{{ $t('common.btn.confirm') }}</el-button>
          <el-button @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { updateStateFunc } from '@/api/seaExport/file'
import $store from '@/store'
import { YGD_TYPE, YJD_TYPE, YQH_TYPE, YTH_TYPE, YTS_TYPE } from '@/class/cargo/model/parameters/FileState'

export default {
  name: 'BatchStateWindow',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    files: { type: Array, required: true },
    title: { type: String, required: true },
    fileState: { type: Number, required: true },
    selectDate: { type: Date, required: true },
    labelName: { type: String, required: true }
  },
  data() {
    return {
      loading: false,
      gridApi: null
    }
  },
  computed: {

  },
  async beforeMount() {

  },
  mounted() {},
  methods: {
    cancel() {
      this.$emit('closePage')
    },
    circulationFileHandler() {
      if (this.selectDate) {
        const fileList = []
        for (const file of this.files) {
          file.state = this.fileState
          this.getFileStateDate(file)
          fileList.push(file)
        }
        // 调用后端保存
        updateStateFunc(fileList, { type: this.fileState }).then(res => {
          this.$message.success('状态转换成功.')
          this.$emit('successHandler', fileList)
        })
      }
    },
    getFileStateDate(file) {
      if (this.fileState === YJD_TYPE.code) {
        file.acceptedDate = this.selectDate
        file.acceptedUser = $store.getters.userId
      }
      if (this.fileState === YGD_TYPE.code) {
        file.filedDate = this.selectDate
        file.filedUser = $store.getters.userId
      } else if (this.fileState === YTS_TYPE.code) {
        file.rebatedDate = this.selectDate
        file.rebatedUser = $store.getters.userId
      } else if (this.fileState === YQH_TYPE.code) {
        file.backDate = this.selectDate
        file.backUser = $store.getters.userId
      } else if (this.fileState === YTH_TYPE.code) {
        file.returnDate = this.selectDate
        file.returnedUser = $store.getters.userId
      }
    }
  }
}
</script>
<style scoped>

ul li {
  list-style: none;
  font-size: 13px;
  color: #909399;
}

.spacing {
  padding-top: 20px;
}
</style>

